import { paths } from 'paths';
import type { NavItemConfig } from 'types/nav';

export const navItems = [
  { key: 'projects', title: 'Projects', href: paths.app.client.projects.home, icon: 'projects' },
  { key: 'plants', title: 'Plants', href: paths.app.client.plants.home, icon: 'plants' },
] satisfies NavItemConfig[];
